export function formatPrice(n) {
  return n != null ? n.toLocaleString('ru-RU') + ' ₽' : ''
}
